// slices/applicationsSlice.js
import { createSlice } from "@reduxjs/toolkit";

const applicationsSlice = createSlice({
  name: "applications",
  initialState: {
    applications: {
      data: [],
      loading: false,
      error: null,
      totalPages: 1,
      currentPage: 1,
    },
    downloadLoading: false, // This is at the top level of 'applications' state
    downloadError: null,    // This is at the top level of 'applications' state
  },
  reducers: {
    fetchApplicationsStart(state) {
      state.applications.loading = true;
      state.applications.error = null;
    },
    fetchApplicationsSuccess(state, action) {
      state.applications.loading = false;
      state.applications.data = action.payload.data;
      state.applications.totalPages = action.payload.totalPages;
      state.applications.currentPage = action.payload.currentPage;
    },
    fetchApplicationsFailure(state, action) {
      state.applications.loading = false;
      state.applications.error = action.payload;
    },
    downloadApplicationStart(state) {
      state.downloadLoading = true;
      state.downloadError = null;
    },
    downloadApplicationSuccess(state) {
      state.downloadLoading = false;
    },
    downloadApplicationFailure(state, action) {
      state.downloadLoading = false;
      state.downloadError = action.payload;
    },
  },
});

export const {
  fetchApplicationsStart,
  fetchApplicationsSuccess,
  fetchApplicationsFailure,
  downloadApplicationStart,
  downloadApplicationSuccess,
  downloadApplicationFailure,
} = applicationsSlice.actions;

export default applicationsSlice.reducer;